var path = 'areas/projects/action-template-fields/field-StepName.html';
var html = "<div> <ui-select ng-model=vm.value append-to-body=true class=form-control> <ui-select-match allow-clear=true placeholder=\"Select Step\">{{$select.selected}}</ui-select-match> <ui-select-choices repeat=\"item in vm.getSelectOptions() | filter:$select.search\"> <span ng-bind-html=\"item | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/action-template-fields/field-StepName.html
// module id = 805091269470956
// module chunks = 1